export default __webpack_public_path__ + "static/media/review-7.a81cea17.png";